import { object, string } from 'yup';

export const ExperienceTeamCreateFormSchema = object({
  name: string().required('Must be a name'),
});
